export default __webpack_public_path__ + "static/media/downloadform.6faafabe.svg";